import React from "react";
import { Button, Drawer, Spin } from "antd";
import { useHistory } from "react-router-dom";
import { LoadingOutlined, CloseOutlined } from "@ant-design/icons";
import s from "./s.module.scss";
import Header from "@share/component/header";
import NumberInput from "@share/component/numberInput";
import { useParams } from "react-router-dom";
import btcIcon from "@share/img/btc-64x64.png";
import ckbIcon from "@share/img/ckb-64x64.png";
import dashIcon from "@share/img/dash-64x64.png";
import bchIcon from "@share/img/bch-64x64.png";
import ethIcon from "@share/img/eth-64x64.png";
import ltcIcon from "@share/img/ltc-64x64.png";
import zecIcon from "@share/img/zec-64x64.png";

import a10Icon from "@share/img/A10.png";
import a10ProIcon from "@share/img/A10pro.png";

import s19ProIcon from "@share/img/S19pro.png";
import s19Icon from "@share/img/S19.png";
import t19Icon from "@share/img/T19.png";

import m30SIcon from "@share/img/M30S.png";
import m30SPlusIcon from "@share/img/M30Splus.png";

import z15Icon from "@share/img/Z15.png";

import paymentIcon from "./payment.jpg";
import qrIcon from "./dbs.jpg";

const itemDetailList = [
  {
    id: 1,
    name: "Antminer S19 Pro",
    price: "8299.00",
    img: s19ProIcon,
    miningUnit: "btc",
    produced: 0.00073946,
    revenue: 24.48,
    dailyCost: 4.68,
    profit: 19.93,
    unitPower: "30 W/T",
    power: "3250 W",
    hashrates: "110 T",
    electricityFee: "0.06 USD/kwh",
    contractTerm: "Perpetual",
    onlineTime: "48 hours",
  },
  {
    id: 2,
    name: "Antminer S19",
    price: "7299.00",
    img: s19Icon,
    miningUnit: "btc",
    produced: 0.00063862,
    revenue: 21.14,
    dailyCost: 3.9,
    profit: 17.24,
    unitPower: "34 W/T",
    power: "3250 W",
    hashrates: "95 T",
    electricityFee: "0.06 USD/kwh",
    contractTerm: "Perpetual",
    onlineTime: "48 hours",
  },
  {
    id: 3,
    name: "Antminer T19",
    price: "5299.00",
    img: t19Icon,
    miningUnit: "btc",
    produced: 0.00056468,
    revenue: 18.7,
    dailyCost: 3.78,
    profit: 14.92,
    unitPower: "38 W/T",
    power: "3150 W",
    hashrates: "84 T",
    electricityFee: "0.06 USD/kwh",
    contractTerm: "Perpetual",
    onlineTime: "48 hours",
  },
  {
    id: 4,
    name: "Whatsminer M30S++",
    price: "9899.00",
    img: m30SPlusIcon,
    miningUnit: "btc",
    produced: 0.0007529,
    revenue: 24.93,
    dailyCost: 4.17,
    profit: 20.76,
    unitPower: "31 W/T",
    power: "3472 W",
    hashrates: "112 T",
    electricityFee: "0.06 USD/kwh",
    contractTerm: "Perpetual",
    onlineTime: "48 hours",
  },
  {
    id: 12,
    name: "Whatsminer M30S",
    price: "5999.00",
    img: m30SIcon,
    miningUnit: "btc",
    produced: 0.00059156,
    revenue: 19.59,
    dailyCost: 4.01,
    profit: 15.57,
    unitPower: "38 W/T",
    power: "3344 W",
    hashrates: "88 T",
    electricityFee: "0.06 USD/kwh",
    contractTerm: "Perpetual",
    onlineTime: "48 hours",
  },
  // not real
  {
    id: 5,
    name: "INNOSOLICON A10",
    price: "6500",
    img: a10Icon,
    miningUnit: "eth",
    produced: 0.04086783,
    revenue: 51.44,
    dailyCost: 1.56,
    profit: 49.88,
    unitPower: "1.8 W/M",
    power: "1300 W",
    hashrates: "720 M",
    electricityFee: "0.06 USD/kwh",
    contractTerm: "Perpetual",
    onlineTime: "48 hours",
  },
  {
    id: 6,
    name: " INNOSOLICON A10 Pro",
    price: "1099",
    img: a10ProIcon,
    miningUnit: "eth",
    produced: 0.04086783,
    revenue: 51.44,
    dailyCost: 1.56,
    profit: 49.88,
    unitPower: "1.8 W/M",
    power: "1300 W",
    hashrates: "720 M",
    electricityFee: "0.06 USD/kwh",
    contractTerm: "Perpetual",
    onlineTime: "48 hours",
  },
  {
    id: 7,
    name: "Antminer Z15",
    price: "3599.00",
    img: z15Icon,
    miningUnit: "zec",
    produced: 0.16353643,
    revenue: 14.4,
    dailyCost: 1.81,
    profit: 12.59,
    unitPower: "3.6 W/K",
    power: "1510 W",
    hashrates: "420 K",
    electricityFee: "0.06 USD/kwh",
    contractTerm: "Perpetual",
    onlineTime: "48 hours",
  },
];

type UP = {
  id: string | undefined;
};

function Miner() {
  const history = useHistory();
  const [visible, setVisible] = React.useState(false);
  const [buyCount, setBuyCount] = React.useState(1);
  const [qrLoading, setQrLoading] = React.useState(false);
  const [qrLink, setQrLink] = React.useState<string | undefined>(undefined);
  const routerParams = useParams<UP>();
  const id = routerParams && routerParams.id;
  const miner = itemDetailList.find((item) => {
    return item.id + "" === id + "";
  });

  React.useEffect(() => {
    if (!id) {
      history.push("/shop");
    }
  });
  if (!miner) {
    return <LoadingOutlined />;
  }
  const totalPriceStr = (parseFloat(miner.price) * buyCount).toFixed(2);
  return (
    <div className={s.wrap}>
      <Header />
      <div className={s.content}>
        <div className={s.item}>
          <div className={s.left}>
            <div className={s.imgWrap}>
              <img src={miner?.img} />
            </div>
            <div className={s.keyWrap}>
              <div className={s.keyItem}>
                <p className={s.value}>{miner.produced + miner.miningUnit}</p>
                <p className={s.label}>Produced(24h)</p>
              </div>
              <div className={s.keyItem}>
                <p className={s.value}>$ {miner.revenue}</p>
                <p className={s.label}>Revenue(24h)</p>
              </div>
            </div>
            <div className={s.keyWrap}>
              <div className={s.keyItem}>
                <p className={s.value}>$ {miner.dailyCost}</p>
                <p className={s.label}>DailyCost(0.06$/kwh)</p>
              </div>
              <div className={s.keyItem}>
                <p className={s.value}>$ {miner.profit}</p>
                <p className={s.label}>Profit(24h)</p>
              </div>
            </div>
          </div>
          <div className={s.right}>
            <h2>{miner.name}</h2>
            <p className={s.price}>${miner.price}</p>
            <div className={s.infoWrap}>
              <div className={s.infoItem}>
                <div className={s.infoLabel}>Power</div>
                <div className={s.infoValue}>{miner.unitPower}</div>
              </div>
              <div className={s.infoItem}>
                <div className={s.infoLabel}>Hashrates</div>
                <div className={s.infoValue}>{miner.hashrates}</div>
              </div>
              <div className={s.infoItem}>
                <div className={s.infoLabel}>Electricity fee</div>
                <div className={s.infoValue}>{miner.electricityFee}</div>
              </div>
            </div>
            <div className={s.infoWrap}>
              <div className={s.infoItem}>
                <div className={s.infoLabel}>Contract term</div>
                <div className={s.infoValue}>{miner.contractTerm}</div>
              </div>
              <div className={s.infoItem}>
                <div className={s.infoLabel}>Online time</div>
                <div className={s.infoValue}>{miner.onlineTime}</div>
              </div>
            </div>
            <div className={s.priceWrap}>
              <div className={s.priceItem}>
                <p className={s.label}>Quantity</p>
                <div className={s.quantityInput}>
                  <NumberInput
                    onChange={(val) => {
                      console.log(val);
                      setBuyCount(val ? parseInt(val + "") : 1);
                    }}
                    min={1}
                    defaultValue={1}
                    precision={0}
                  />
                </div>
              </div>
              <div className={s.priceItem}>
                <p className={s.label}>Total</p>
                <div className={s.totalPrice}>$ {totalPriceStr}</div>
              </div>
            </div>

            <div className={s.paymentWrap}>
              <div className={s.payMethod}>
                <img src={paymentIcon} className={s.paymentMethod} />
              </div>
              <Button
                onClick={() => {
                  return;
                  setQrLoading(true);
                  setVisible(true);
                  setTimeout(() => {
                    setQrLink(qrIcon);
                    setQrLoading(false);
                  }, 500);
                }}
                type="primary"
                className={s.buttonStyle1}
                size="large"
              >
                Buy Now
              </Button>
            </div>
          </div>
        </div>
      </div>
      <Drawer
        placement="right"
        closable={false}
        width={400}
        onClose={() => {
          setVisible(false);
          setQrLink(undefined);
        }}
        visible={visible}
      >
        <div className={s.drawer}>
          <div className={s.drawerHeader}>
            <span className={s.drawerHeaderHolder} />
            <p>PAYMENT - PAYPAL</p>
            <CloseOutlined
              onClick={() => {
                setVisible(false);
              }}
              style={{ width: "30px", fontSize: "20px" }}
            />
          </div>
          <div className={s.amountWrap}>
            <p className={s.amountLabel}>Payment Amount (SGD)</p>
            <p className={s.amountValue}>
              {(parseFloat(totalPriceStr) * 1.4).toFixed(2)}
            </p>
          </div>
          <Spin className={s.qrWrap} spinning={qrLoading}>
            <div className={s.qrCode}>
              <img src={qrLink} />
            </div>
            <div className={s.qrTips}>
              <p>Open Paypal from your mobile</p>
              <p>Scan Qrcode and finish payment</p>
            </div>
          </Spin>
          <div className={s.prdInfo}>
            <div className={s.prdInfoRow}>
              <div className={s.prdInfoLabel}>Order NO.</div>
              <div className={s.prdInfoValue}>219281928282828282</div>
            </div>
            <div className={s.prdInfoRow}>
              <div className={s.prdInfoLabel}>Total</div>
              <div className={s.prdInfoValue}>{totalPriceStr} USD</div>
            </div>
          </div>
          <div className={s.buttonWrap}>
            <Button type="primary" className={s.buttonStyle2} size="large">
              Finish Payment
            </Button>
          </div>
        </div>
      </Drawer>
    </div>
  );
}

export default Miner;
